module.exports = __webpack_public_path__ + "static/media/montserrat-light.85a0301e.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/montserrat-light.otf
// module id = 535
// module chunks = 0